import React, { useState } from "react";

// components
import BottomBanner from "../elements/BottomBanner";
import LandingBanner from "../elements/LandingBanner";
import PopularGameSlider from "../elements/games_elements/PopularGameSlider";
import FeturedItem from "../elements/FeturedItem";
import PromotionSlider from "../elements/PromotionSlider";
import GameSlider from "../elements/games_elements/GameSlider";
import Faqs from "../elements/Faqs";

export default function PokerLanding(props) {
  return (
    <div className="joker_landing_page">
      <LandingBanner {...props} />
      <PopularGameSlider {...props} />
      <div className="container">
        <GameSlider
          categoryName="Popular"
          category="popular"
          perPage="20"
          {...props}
        />

        <GameSlider
          categoryName="Live Casino"
          category="live_casino"
          perPage="20"
          {...props}
        />
      </div>
      <PromotionSlider {...props} />

      <FeturedItem {...props} />

      <BottomBanner {...props} />
      <Faqs {...props} />
    </div>
  );
}
